<template>
  <div id="home-page" class="page">
    <el-row class="hp-row content-default" type="flex">
      <el-col class="right content-column">
        <div class="desc">
          <h1> {{$t('label.loginOKString1')}} </h1>
          <h1> {{$t('label.loginOKString2')}} </h1>

          <p> {{$t('label.loginOKString3')}} </p>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" src="./home.scss"></style>
<script src="./home.js"></script>
